export const StudentDataActionTypeEnum = {
    DELETE_STUDENTS: {
        code: "DELETE_STUDENTS",
        description: "Удалить обучающихся и все их данные по ИИН",
    },
    UPDATE_DIFFERENTIATED_GRANT : {
        code: "UPDATE_DIFFERENTIATED_GRANT",
        description: "Обновить значение поля 'Дифференцированный грант'",
    },

};